export enum EventCategory {
  ACCOUNT = 'account',
  CHAT = 'chat',
  DASHBOARD = 'dashboard',
  ENCYCLOPEDIA = 'encyclopedia',
  HOMEBASE = 'homebase',
  MATH_DRILLS = 'math drills',
  NEWSLETTER = 'newsletter',
  SEARCH = 'search',
  SETTINGS = 'settings',
  STUDENT_PANEL = 'student panel',
  INFRASTRUCTURE = 'infrastructure',
  AVATAR = 'avatar',
  NAVIGATION = 'navigation',
}

export enum Modal {
  HOMEBASE = 'homebase',
  CHAT = 'chat',
  CAMPAIGN = 'campaign',
}

export enum EventAction {
  LOGIN_EMAIL = 'login_email',
  LOGIN_FACEBOOK = 'login_facebook',
  LOGIN_GOOGLE = 'login_google',
  LOGIN_FEIDE = 'login_feide',
  LOGOUT = 'logout',
  CREATE_NEW_ACCOUNT = 'create_new_account',
  SIGN_UP_NEWSLETTER = 'signs_up_to_newsletter',
  USES_SEARCH_BAR = 'uses_the_searchbar',
  USES_CHAT = 'uses_the_chat',
  INTERACTS_WITH_BOOTCAMP = 'interacts_with_bootcamp',
  AUTH_TOKEN = 'authenticate_with_token',
  PAGE_VIEW = 'page_view',
  MODAL_VIEW = 'modal_view',
  BUTTON_CLICK = 'button_click',
  SAVED_AVATAR = 'saved_a_new_avatar',
  COMPLETED_DRILL_MCT = 'completed_a_multiple_choice_test', // MCQ - multiple choice test
  CLICK = 'click',
  TYPES_IN_THE_SEARCHBAR = 'types_in_the_searchbar',
  SEARCH_RES_CLICK = 'search_card_result_card_click',
  SENDS_QUESTION = 'sends_question',
  CLICK_CATEGORY = 'click-category',
  CLICK_BOOTCAMP_BADGE = 'click_bootcamp_badge',
  CLICK_TROPHY = 'click_trophy',
  CLICK_SUBBADGE = 'click_sub_badge',
}

type EventLabel = 'Successful' | 'Unsuccessful' | string

export interface Event {
  [key: string]: any
  eventCategory?: EventCategory
  eventAction?: EventAction
  eventLabel?: EventLabel
  eventValue?: number
  nonInteraction?: boolean
}

function getLabel(success: boolean | string): EventLabel {
  if (typeof success === 'boolean') return success ? 'Successful' : 'Unsuccessful'
  return success
}

export const LOG_IN = (eventAction: EventAction, success: boolean | string, userId?: string): Event => ({
  product: EventCategory.ACCOUNT,
  event: eventAction,
  result: getLabel(success),
  userId,
})

export const AUTH_TOKEN = (userId: string): Event => ({
  product: EventCategory.ACCOUNT,
  event: EventAction.AUTH_TOKEN,
  action: getLabel(true),
  userId,
})

export const LOG_OUT = (success: boolean | string): Event => ({
  product: EventCategory.ACCOUNT,
  event: EventAction.LOGOUT,
  action: getLabel(success),
  userId: null,
})

export const MODAL_VIEW = (modal: Modal): Event => ({
  product: EventCategory.ACCOUNT,
  event: EventAction.MODAL_VIEW,
  label: modal,
})

export const CHECK_CLICK_HOMEBASE = (label: string): Event => ({
  product: EventCategory.HOMEBASE,
  event: EventAction.CLICK,
  label,
})

export const BUTTON_CLICK_HOMEBASE = (buttonDescription: string): Event => ({
  product: EventCategory.HOMEBASE,
  event: EventAction.BUTTON_CLICK,
  label: buttonDescription,
})

export const CHAT = (chatEvent: string): Event => ({
  product: EventCategory.CHAT,
  event: EventAction.USES_CHAT,
  label: chatEvent,
})

export const CHAT_MESSAGE: Event = {
  product: EventCategory.CHAT,
  event: EventAction.USES_CHAT,
  action: 'clicks send',
}

export const CHAT_RESPONSE: Event = {
  product: EventCategory.CHAT,
  event: EventAction.USES_CHAT,
  action: 'gets response',
}
